import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as router from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import DefaultHeader from './DefaultHeader';
import DefaultAside from './DefaultAside';
import { CFooter, CHeader, CBreadcrumb, CSidebarNav, CSidebar, CSidebarNavDropdown, CSidebarNavItem, CSidebarNavTitle, CBreadcrumbItem } from '@coreui/react';
import ErrorModal from '../../../components/modals/ErrorModal';
import DefaultSpinner from '../../../components/loaders/DefaultSpinner';
import { adminNavRoutes, appBreadcrumbRoutes } from '../../../config';
import { adminRoutes } from '../../../routes/_adminRoutes';
import { closeErrorModal } from '../../../redux/methods/generic';
import styles from './index.module.scss';
import { asHtmlElement } from '../../../lib/DOM';
import clsx from 'clsx';
// import { setIsLoading } from '../../../features/loaders/slice';
// import { Link } from '@material-ui/core';

const propTypes = {
    isLoading: PropTypes.bool,
    error: PropTypes.string,
    errorAdditionalData: PropTypes.object,
    errorForceLogout: PropTypes.bool,
    closeErrorModal: PropTypes.func,
    children: PropTypes.node,
    isShopCategoryActive: PropTypes.bool
};

/**
 * @param {string} pathname
 * @param {import('../../../config/_appBreadcrumbRoutes').BreadcrumbItem[]} items
 * @returns {import('../../../config/_appBreadcrumbRoutes').BreadcrumbItem[]}
 */
function resolveBreadcrumbs(pathname, items)
{
    return items.filter(item =>
    {
        // if (item.exact) { return pathname === item.path; }
        return pathname.startsWith(item.path);
    })
    .sort((a, b) => a.path.length - b.path.length);
}

/**
 * @param {SideNavHeader | SideNavItem} item
 * @param {AppRouterInstance} router
 * @param {*} key
 * @param {import("@reduxjs/toolkit").Dispatch} dispatch
 */
function renderItem(item, router, key, dispatch)
{
    const icon = item.icon ? <i className={`c-sidebar-nav-icon ${item.icon}`} /> : null;
    if (item.title) { return <CSidebarNavTitle key={key}>{item.name}</CSidebarNavTitle>; }
    if (item.children)
    {
        const element =
        <CSidebarNavDropdown name={item.name} icon={icon} key={key}>
            {item.children.map((child, index) => renderItem(child, router, index, dispatch))}
        </CSidebarNavDropdown>;
        return element;
    }
    else
    {
        if (!item.url) { return <div key={key}>wrong</div>; }
        return <CSidebarNavItem key={key} name={item.name} icon={icon} onClick={() => { router.push(item.url); }} />;
    }
}

const DefaultLayout = ({
    isLoading,
    error,
    errorAdditionalData,
    errorForceLogout,
    closeErrorModal,
    children,
    isShopCategoryActive,
    isConnectedToERP,
    user,
    // ...rest
}) => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const [minimized, setMinimized] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const [showSidebar, setShowSidebar] = useState(true);
    const location = router.useLocation();
    /** @type {any} */
    const translations = intl.messages.defaultLayout;
    const history = router.useHistory();
    const disabledSectionsIds = [];

    if (!isShopCategoryActive || !isConnectedToERP) {
        disabledSectionsIds.push('ROUTE_ASSORTMENT_PRODUCTS_CATEGORY_ASSIGN');
    }

    if (!user.features?.includes('Products')) {
        disabledSectionsIds.push('ROUTE_ASSORTMENT_PRODUCTS');
    }

    if (!user.features?.includes('Categories')) {
        disabledSectionsIds.push('ROUTE_ASSORTMENT_CATEGORIES');
    }

    if (!user.features?.includes('Users')) {
        disabledSectionsIds.push('ROUTE_GLOBAL_SETTINGS_USERS');
    }

    // const dropdownSidebarItems = [...document.getElementsByClassName('nav-item nav-dropdown')];

    const reset = () =>
    {
        const input = asHtmlElement(document.getElementById('navSearchText'), 'input');
        if (!input) { return; }
        input.value = '';
        const nav = document.getElementsByClassName('c-sidebar-nav');
        if (nav.length === 0) { return; }
        const firstNav = nav[0];
        const navItems = [...firstNav.querySelectorAll('.c-sidebar-nav-item, .c-sidebar-nav-toggle, .c-sidebar-nav-dropdown')];
        navItems.forEach(item =>
        {
            item.classList.remove('c-show');
            item.classList.remove('found');
            item.classList.remove('hidden');
        });
        const navTitles = [...firstNav.getElementsByClassName('c-sidebar-nav-title')];
        navTitles.forEach(title => { title.classList.remove('hidden'); });
    };

    /** @type {(value: string) => void} */
    const search = (value) =>
    {
        const nav = document.getElementsByClassName('c-sidebar-nav');
        if (value === '' || nav.length === 0) { reset(); return; }
        const searchText = value.toLowerCase();
        const firstNav = nav[0];

        // wszystkie pozycje menu
        const navItems = [...firstNav.querySelectorAll('.c-sidebar-nav-item, .c-sidebar-nav-toggle, .c-sidebar-nav-dropdown')];

        // wszystkie pozycje rozwijane
        const navDropdowns = [...firstNav.getElementsByClassName('c-sidebar-nav-dropdown')];

        // wyczyszczenie znaczników poprzedniego wyszukiwania i zwinięcie wszystkich menu
        navItems.forEach(item => {
            item.classList.remove('c-show');
            item.classList.remove('found');
            item.classList.remove('hidden');
        });

        // zamknięcie wszystkich pozycji rozwijanych
        navDropdowns.forEach(item => item.classList.remove('c-show'));

        navItems.forEach(item =>
        {
            if (item.getElementsByTagName('A')[0].innerText.toLowerCase().indexOf(searchText) > -1)
            {
                item.classList.add('found');
                // jeśli znaleziony element jest w menu rozwijanym, to otwieramy to menu
                if (item.parentElement && item.parentElement.classList.contains('c-sidebar-nav-dropdown-items'))
                {
                    if (item.parentElement.parentElement) { item.parentElement.parentElement.classList.add('c-show'); }
                }
            }
        });

        navDropdowns.forEach(item =>
        {
            if (!item.classList.contains('c-show') && !item.classList.contains('found')) {
                item.classList.add('hidden');
            }
        });

        navItems.filter(item => !item.classList.contains('c-sidebar-nav-dropdown')).forEach(item => {
            if (!item.classList.contains('found')) {
                const insideFoundDropdown =
                    item.parentElement.classList.contains('c-sidebar-nav-dropdown-items') &&
                    item.parentElement.parentElement.classList.contains('found');

                if (!insideFoundDropdown) {
                    item.classList.add('hidden');
                }
            }
        });

        const navTitles = [...firstNav.getElementsByClassName('c-sidebar-nav-title')];

        navTitles.forEach(title => {
            let next = title.nextSibling;
            while (next && !next.classList.contains('c-sidebar-nav-title')) {
                if (!next.classList.contains('hidden')) {
                    title.classList.remove('hidden');
                    return;
                }
                next = next.nextSibling;
            }
            title.classList.add('hidden');
        });

        firstNav.scrollTo(0, 0);
    };

    //func to close dropdown item when open another
    // const openClassToggleHandler = (e) => {
    //     if (e.target.classList.contains('nav-dropdown-toggle')) {
    //         if (e.target.parentElement.classList.contains('open')) {
    //             dropdownSidebarItems.forEach(element => element.classList.remove('open'));
    //             e.target.parentElement.classList.add('open');
    //         }
    //         else {
    //             e.target.parentElement.classList.remove('open');
    //         }
    //     }
    //     else if (e.target.classList.contains('nav-link') && !e.target.closest('.nav-dropdown')) {
    //         dropdownSidebarItems.forEach(element => element.classList.remove('open'));
    //     }
    // };

    const getFullRouteName = (routes = adminRoutes, path = '') =>
    {
        for (const key in routes)
        {
            let name = translations.appSidebar.positions[routes[key].id];

            if (routes[key].path === history.location.pathname) {
                return path + name;
            }

            if (routes[key].children) {
                name = getFullRouteName(routes[key].children, (path === '' ? '' : path + ' / ') + name + ' / ');
                if (name !== null) {
                    return name;
                }
            }
        }
        return null;
    };

    useEffect(() => {
        const title = getFullRouteName();
        const additionalInfo = `${window.location.hostname} - `;
        document.title = additionalInfo + (title || 'Connectico');
        return () => {
            document.title = additionalInfo + 'Connectico';
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.location.href]);

    const breadcrumbItems = resolveBreadcrumbs(location.pathname, appBreadcrumbRoutes(translations.appSidebar));

    return (
        <div className="c-app">
            <CHeader fixed>
                <DefaultHeader onLeftToggler={() => setShowSidebar(v => !v)} onRightToggler={() => setShowSettings(v => !v)} />
            </CHeader>
            <div className={clsx("c-wrapper", { 'sidebar-hidden': !showSidebar, 'sidebar-minimized': minimized })}>
                <div className="c-body">
                    <CSidebar
                        fixed
                        unfoldable={true}
                        className={minimized ? 'c-sidebar-minimized side-navigation' : 'side-navigation'}
                        show={showSidebar}
                        onShowChange={(isShown) => setShowSidebar(isShown === true)}
                    >
                        {/* <AppSidebarForm /> */}

                        <div className='sidebar-search'>
                            <input id="navSearchText" type="text" placeholder="szukaj pozycji menu" onChange={(e) => { search(e.target.value); }}></input>
                            <i className="fa fa-search" style={{ fontSize: '18px', color: 'gray' }} />
                            <i className="fa fa-remove" style={{ fontSize: '18px', color: 'gray', marginLeft: '10px', visibility: 'visible', cursor: 'pointer' }} onClick={() => { search(''); }} />
                        </div>

                        <CSidebarNav>
                            {adminNavRoutes(translations.appSidebar, disabledSectionsIds, '').items.map((item, index) => renderItem(item, history, index, dispatch))}
                        </CSidebarNav>
                        <button className="c-sidebar-minimizer c-brand-minimizer" type="button" onClick={() => setMinimized(prev => !prev)}></button>
                    </CSidebar>
                    <main className="c-main position-relative">
                        <CBreadcrumb key={`defaultLayout-${intl.locale}`} className={styles.breadcrumbs}>
                            {breadcrumbItems.map((item, index) =>
                            (
                                <CBreadcrumbItem key={index} active={index === breadcrumbItems.length - 1}>
                                    {index === breadcrumbItems.length - 1 ? item.name : <router.Link to={item.path}>{item.name}</router.Link>}
                                </CBreadcrumbItem>)
                            )}
                        </CBreadcrumb>
                        {children}
                        <DefaultSpinner isLoading={isLoading} />
                    </main>
                    <div className={'c-sidebar c-sidebar-right c-sidebar-light c-sidebar-fixed' + (showSettings ? ' c-sidebar-show' : '')}>
                        <DefaultAside />
                    </div>
                </div>
                <CFooter>Copyright © - Connectico {new Date().getFullYear()}</CFooter>
            </div>
            <ErrorModal
                error={error}
                errorAdditionalData={errorAdditionalData}
                errorForceLogout={errorForceLogout}
                closeErrorModal={closeErrorModal}
                buttonLabel={translations.appGlobal.errorModal.close}
                header={translations.appGlobal.errorModal.header}
            />
        </div>
    );
};

DefaultLayout.propTypes = propTypes;

const mapStateToProps = state => ({
    isLoading: state.loaders.global,
    error: state.errors.global,
    errorAdditionalData: state.errors.additionalData,
    errorForceLogout: state.errors.forceLogout,
    isShopCategoryActive: state.appInit.isShopCategoryActive,
    isConnectedToERP: state.appInit.isConnectedToERP,
    user: state.auth.user
});

const mapDispatch = {
    closeErrorModal
};

export default connect(mapStateToProps, mapDispatch)(DefaultLayout);